var default_styles_default = {
  "button_container": "vTN3s",
  "button_margin": "TUb0X",
  "button_text": "vJaYf",
  "button_size_content": "FAw0y"
};
export {
  default_styles_default as default
};
//# sourceMappingURL=default-styles-scss.js.map
